var users = [
  {
    id: "101",
    name: "Kevin Cobb",
    email: " kevincobb@gmail.com",
    salary: 40000,
    img: "https://i.ibb.co/3SCcrWS/download-5.jpg",
    phone: " 1-770-736-8031 x56442",
    company: {
      name: "Romaguera-Crona",
      catchPhrase: "Multi-layered client-server neural-net",
      bs: "harness real-time e-markets",
    },
  },
  {
    id: "102",
    name: "Mark Zuckerberg",
    email: " markjkd@gmail.com",
    salary: 40000,
    img: "https://i.ibb.co/Gs86RKW/download.jpg",
    phone: " 1-770-736-8031",
    company: {
      name: "Deckow-Crist",
      catchPhrase: "Proactive didactic contingency",
      bs: "synergize scalable supply-chains",
    },
  },
  {
    id: "103",
    name: "Sheldon Weber",
    email: " sheldomddh@gmail.com",
    salary: 40000,
    img: "https://i.ibb.co/LYdKvfv/download.jpg",
    phone: " 010-692-6593 x09125",
    company: {
      name: "Romaguera-Jacobson",
      catchPhrase: "Face to face bifurcated interface",
      bs: "e-enable strategic applications",
    },
  },
  {
    id: "104",
    name: "Saman Larson",
    email: " jdhuhdu@gmail.com",
    salary: 40000,
    img: "https://i.ibb.co/wwNTQ4K/download-2.jpg",
    phone: " 1-770-736-803553",
    company: {
      name: "Robel-Corkery",
      catchPhrase: "Multi-tiered zero tolerance productivity",
      bs: "transition cutting-edge web services",
    },
  },
  {
    id: "105",
    name: "Garry Barnes",
    email: " jdbjhdjdds@gmail.com",
    salary: 40000,
    img: "https://i.ibb.co/2SQKvSS/download-1.jpg",
    phone: " 1-770-736-8031452",
    company: {
      name: "Keebler LLC",
      catchPhrase: "User-centric fault-tolerant solution",
      bs: "revolutionize end-to-end systems",
    },
  },
  {
    id: "106",
    name: "Mrs. Dennis Schulist",
    email: " Karley_Dach@jasper.info",
    salary: 40000,
    img: "https://i.ibb.co/85DcMCj/images-1.jpg",
    phone: " 1-477-935-8478 x6430",
    company: {
      name: "Considine-Lockman",
      catchPhrase: "Synchronised bottom-line interface",
      bs: "e-enable innovative applications",
    },
  },
  {
    id: "107",
    name: "Chelsey Dietrich",
    email: " Lucio_Hettinger@annie.ca",
    salary: 40000,
    img: "https://i.ibb.co/6F07JDP/images-5.jpg",
    phone: " (254)954-1289",
    company: {
      name: "Johns Group",
      catchPhrase: "Configurable multimedia task-force",
      bs: "generate enterprise e-tailers",
    },
  },
  {
    id: "108",
    name: "Kurtis Weissnat",
    email: " Telly.Hoeger@billy.biz",
    salary: 40000,
    img: "https://i.ibb.co/Brb2y2M/images-2.jpg",
    phone: " 210.067.6132",
    company: {
      name: "Abernathy Group",
      catchPhrase: "Implemented secondary concept",
      bs: "e-enable extensible e-tailers",
    },
  },
  {
    id: "109",
    name: "Glenna Reichert",
    email: " Chaim_McDermott@dana.io",
    salary: 40000,
    img: "https://i.ibb.co/52R2rN7/images-3.jpg",
    phone: " (775)976-6794 x41206",
    company: {
      name: "Yost and Sons",
      catchPhrase: "Switchable contextually-based project",
      bs: "aggregate real-time technologies",
    },
  },
  {
    id: "110",
    name: "Nicholas Runolfsdottir",
    email: " kevincobb@gmail.com",
    salary: 40000,
    img: "https://i.ibb.co/6btNzLc/images-6.jpg",
    phone: " 586.493.6943 x140",
    company: {
      name: "Hoeger LLC",
      catchPhrase: "Centralized empowering task-force",
      bs: "target end-to-end models",
    },
  },
  {
    id: "111",
    name: "Clementina DuBuque",
    email: " Rey.Padberg@karina.biz",
    salary: 40000,
    img: "https://i.ibb.co/MhBB32m/images-7.jpg",
    phone: " 024-648-3804",
    company: {
      name: "YoYo LLC",
      catchPhrase: "Centralized empowering task-force",
      bs: "target end-to-end models",
    },
  },
  {
    id: "112",
    name: "Amos Berry",
    email: " amos25ws@gmail.com",
    salary: 40000,
    img: "https://i.ibb.co/1zGbRPL/images-4.jpg",
    phone: " 0242851-524",
    company: {
      name: "TOPC tech",
      catchPhrase: "Centralized empowering task-force",
      bs: "target end-to-end models",
    },
  },
  {
    id: "113",
    name: "Clementine Bauch",
    email: " Nathan@yesenia.net",
    salary: 30000,
    img: "https://i.ibb.co/gM99ywc/download-4.jpg",
    phone: " 1-463-123-4447",
    company: {
      name: "ICICI LTD",
      catchPhrase: "Centralized empowering task-force",
      bs: "target end-to-end models",
    },
  },
  {
    id: "114",
    name: "Ervin Howell",
    email: " Shanna@melissa.tv",
    salary: 70000,
    img: "https://i.ibb.co/1qksVPY/download-3.jpg",
    phone: " 010-692-6593 x09125",
    company: {
      name: "hojdhh",
      catchPhrase: "Centralized empowering task-force",
      bs: "target end-to-end models",
    },
  },
  {
    id: "115",
    name: "Leanne Graham",
    email: " Sincere@april.biz",
    salary: 50000,
    img: "https://i.ibb.co/9qGh95S/download-6.jpg",
    phone: " 1-770-736-8031 x56442",
    company: {
      name: "Faltu Tech",
      catchPhrase: "Centralized empowering task-force",
      bs: "target end-to-end models",
    },
  },
];
export default users;
